import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react'
import { ThemeProvider, CssBaseline } from "@mui/material";
import './index.css';
import App from './App';
import store from "./redux/store";
import { NotificationProvider } from './redux/NotificationProvider';
import scoTheme from "./theme/scoTheme";


const persistor = persistStore(store);

const root = createRoot(document.getElementById('root'))
root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={scoTheme}>
            <CssBaseline />
            <NotificationProvider>
              <App />
            </NotificationProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </React.StrictMode>
);
